export default __webpack_public_path__ + "static/N0135-845b67e6e87942851117384184182225.png";